var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "#E0E0E0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6769 14.7857C17.1102 14.7857 20.2102 11.7332 20.2102 7.34516C20.2102 2.95714 17.1102 0 12.6769 0H4.16854C3.82338 0 3.54354 0.275846 3.54354 0.616071V11.2244H0.835205C0.490049 11.2244 0.210205 11.5003 0.210205 11.8405V14.1696C0.210205 14.5099 0.490049 14.7857 0.835205 14.7857H3.54354V16.4286H0.835205C0.490049 16.4286 0.210205 16.7044 0.210205 17.0446V19.0982C0.210205 19.4384 0.490049 19.7143 0.835205 19.7143H3.54354V22.3839C3.54354 22.7242 3.82338 23 4.16854 23H7.21854C7.56369 23 7.84354 22.7242 7.84354 22.3839V19.7143H16.2519C16.597 19.7143 16.8769 19.4384 16.8769 19.0982V17.0446C16.8769 16.7044 16.597 16.4286 16.2519 16.4286H7.84354V14.7857H12.6769ZM7.84354 3.52947H11.9435C14.3769 3.52947 15.8435 5.02396 15.8435 7.34516C15.8435 9.69814 14.3769 11.2244 11.8769 11.2244H7.84354V3.52947Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRub);
export default __webpack_public_path__ + "static/media/Rub.0ac9b14b10f8f239bd4a2a4c3b836704.svg";
export { ForwardRef as ReactComponent };